export const BodyContentSymbol = Symbol.for('BodyContentSymbol')
